// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"9eb7eb79","238":"c99ef200","686":"6bff42f2"}[chunkId] + ".chunk.js";
};